import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { errorAutorizacion } from "../../../../inicio/modulos/inicioActions";
import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import * as moment from "moment";
import { FiltroConsultarEnvioMora, MoraNotas } from "../modelo/EnviosMoraModelo";
import {
    CONSULTAR_ENVIOS_MORA,
    TABLA_ENVIOS_MORA_CONSULTADO,
    ERROR_CONSULTANDO_ENVIOS_MORA,
    DESCARGAR_XLS_ENVIOS_MORA,
    EXITO_DESCARGAR_ENVIOS_MORA_XLS,
    ERROR_DESCARGAR_ENVIOS_MORA_XLS,
    tablaEnviosMoraConsultado,
    errorConsultandoEnviosMora,
    exitoDescargarEnviosMoraXls,
    errorDescargarEnviosMoraXls
} from "./consultaEnvioMoraActions";
import { CODIGOS_CONSULTA } from "../../config_general_recibo/modelo/CodigosConsulta";
import {
    cabeceraReporteEnvioManualMora,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";

export const consultarEnviosMoraEpic = action$ =>
    action$.ofType(CONSULTAR_ENVIOS_MORA)
        .mergeMap((action: any) => {

            const url = `sat/consultar/envio-manual-mora?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return tablaEnviosMoraConsultado(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoEnviosMora()];
                });
        });

export const descargarXlsEnviosMoraEpic = action$ =>
    action$.ofType(DESCARGAR_XLS_ENVIOS_MORA)
        .mergeMap((action: any) => {

            const url = `sat/consultar/envio-manual-mora?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    const excelBlob: Blob = construirXLS(respuesta.datosEntidad);
                    const nombreArchivo = `reporte_envio_manual_mora_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                    fileDownload(
                        excelBlob,
                        nombreArchivo,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return exitoDescargarEnviosMoraXls();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorDescargarEnviosMoraXls()];
                });
        });

export const consultaEnviosMoraReducer = (state = {
    estadoConsulta: REQUEST.NONE,
    estadoDescarga: REQUEST.NONE,
    mensajeConsulta: undefined,
    moraNotas: [],
    totalMoraNotasConsulta: 0,
    paginas: 0,
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_ENVIOS_MORA:
            return {
                ...state,
                estadoConsulta: REQUEST.PENDING,
                moraNotas: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalParametrosConsulta: 0,
                paginaActual: action.filtro.paginaActual,
            };
        case TABLA_ENVIOS_MORA_CONSULTADO:
            return {
                ...state,
                estadoConsulta: REQUEST.SUCCESS,
                moraNotas: action.datosEntidad,
                paginas: action.paginas,
                totalMoraNotasConsulta: action.totalDatos
            };
        case ERROR_CONSULTANDO_ENVIOS_MORA:
            return {
                ...state,
                estadoConsulta: REQUEST.ERROR
            };
        case DESCARGAR_XLS_ENVIOS_MORA:
            return {
                ...state,
                estadoDescarga: REQUEST.PENDING
            };
        case EXITO_DESCARGAR_ENVIOS_MORA_XLS:
            return {
                ...state,
                estadoDescarga: REQUEST.SUCCESS
            };
        case ERROR_DESCARGAR_ENVIOS_MORA_XLS:
            return {
                ...state,
                estadoDescarga: REQUEST.ERROR
            };
        default:
            return state;
    }
};

const obtenerFiltroConsulta = (filtro: FiltroConsultarEnvioMora) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.dniEmpleador) params.set('dniEmpleador', filtro.dniEmpleador);
        if (filtro.poliza) params.set('poliza', filtro.poliza);
        if (filtro.consecutivo) params.set('consecutivo', filtro.consecutivo.toString());
        if (filtro.tipoFecha && filtro.fecha && filtro.complementoFecha) {
            params.set(filtro.tipoFecha, filtro.fecha);
            params.set('complementoFecha', filtro.complementoFecha.toString());
        }
        params.set('codigoConsulta', CODIGOS_CONSULTA.CONSULTA_ENVIO_MANUAL_MORA.toString());
        if (Number.isInteger(filtro.paginaActual)) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');

    }

    return params.toString();
};

const construirXLS = (datos: Array<MoraNotas>) => {
    if (!datos || !datos.length)
        return;
    /*Libros a generar en el XLS*/
    const libro = 'Reporte Envio Manual Mora';
    const librosXLS = [libro];

    const datosMora = [];

    const validarVacio = (dato: any) => {
        return dato ? dato : '';
    };

    datos.forEach(registro => {

        datosMora.push([
            { value: validarVacio(registro.consecutivo) },
            { value: validarVacio(registro.consecutivoProceso) },
            { value: validarVacio(registro.dni) },
            { value: validarVacio(registro.poliza) },
            { value: validarVacio(registro.periodo) },
            { value: validarVacio(registro.dniIngreso) },
            { value: validarVacio(registro.fechaIngresa) },
            { value: validarVacio(registro.consecutivoMarca) },
            { value: validarVacio(registro.fechaEnvioSAT) },
            { value: validarVacio(registro.fechaDesmarcaSAT) },
            { value: validarVacio(registro.consecutivoDesmarca) },
            { value: validarVacio(registro.valorNotas) },
            { value: validarVacio(registro.tipoMora) },
            { value: validarVacio(registro.justificacionMarca) },
            { value: validarVacio(registro.dniDesmarca) },
            { value: validarVacio(registro.justificacionDesmarca) },
            { value: validarVacio(registro.tipoRegistro) },
            { value: validarVacio(registro.jsonMensajeMarca) },
            { value: validarVacio(registro.jsonMensajeDesmarca) }
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libro,
        cabecera: cabeceraReporteEnvioManualMora(),
        datos: datosMora,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_envio_mora/modulos/consultaEnvioMoraReducers.ts